import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

const MEMORY_THREADS_PAGE_SIZE = 50;

export const useMastraThreads = ({
    agentId,
    resourceId,
    enabled = true,
}: {
    agentId: string;
    resourceId: string;
    enabled?: boolean;
}) => {
    const mastraClient = useMastraClient();

    return useQuery({
        queryKey: ['mastraMemoryThreads', agentId, resourceId],
        queryFn: async () => {
            try {
                const response = await mastraClient.listMemoryThreads({
                    agentId,
                    resourceId,
                    orderBy: { field: 'updatedAt', direction: 'DESC' },
                    perPage: MEMORY_THREADS_PAGE_SIZE,
                });

                return response.threads ?? [];
            } catch (err) {
                captureException(err);
                throw err;
            }
        },
        enabled: enabled && resourceId !== '',
        refetchOnWindowFocus: false,
    });
};
